import { ref, watch } from "vue";

/**
 * One-shot signal: resolves once the Materials page's own inventory fetch has settled and its
 * anchors exist in the DOM. Same shape as useLibraryReadySignal.ts / useViewerReadySignal.ts.
 */
const isReady = ref(false);

export function markMaterialsReady(): void {
  isReady.value = true;
}

export function resetMaterialsReady(): void {
  isReady.value = false;
}

export function waitForMaterialsReady(): Promise<void> {
  if (isReady.value) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const stop = watch(isReady, (ready) => {
      if (ready) {
        stop();
        resolve();
      }
    });
  });
}
